/**
 * RidesSettingsService
 * Module-wide Rides settings singleton (admin).
 * Route: rides/api/rides/admin/settings
 */
import { BaseService } from '../base/BaseService';
/** Service for the RideSetting singleton (get / update). Roles Admin,RidesAdmin. */
export class RidesSettingsService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? RidesSettingsService.DEFAULT_SERVICE_PATH,
            basePath: RidesSettingsService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** GET api/rides/admin/settings */
    async get() {
        const response = await this.getRaw();
        if (!response.data)
            throw new Error('Rides settings not found');
        return response.data;
    }
    getRaw() {
        return this.http.get(this.buildUrl());
    }
    /** PUT api/rides/admin/settings — patch semantics (only supplied fields change). */
    async update(request) {
        const response = await this.updateRaw(request);
        if (!response.data)
            throw new Error('Failed to update Rides settings');
        return response.data;
    }
    updateRaw(request) {
        return this.http.put(this.buildUrl(), request);
    }
    /** GET api/rides/admin/copy — every RideCopy row (public + private). */
    async getCopy() {
        const response = await this.getCopyRaw();
        return response.data ?? [];
    }
    getCopyRaw() {
        return this.http.get(this.copyUrl());
    }
    /** PUT api/rides/admin/copy/{copyKey} — change one text; the portal/worker pick it up from cache immediately. */
    async updateCopy(copyKey, request) {
        const response = await this.updateCopyRaw(copyKey, request);
        if (!response.data)
            throw new Error('Failed to update Rides copy');
        return response.data;
    }
    updateCopyRaw(copyKey, request) {
        return this.http.put(`${this.copyUrl()}/${encodeURIComponent(copyKey)}`, request);
    }
    /** The copy endpoints live beside settings: api/rides/admin/copy. */
    copyUrl() {
        return this.buildUrl().replace(/admin\/settings$/, 'admin/copy');
    }
}
RidesSettingsService.DEFAULT_SERVICE_PATH = 'rides';
RidesSettingsService.BASE_PATH = 'api/rides/admin/settings';
//# sourceMappingURL=RidesSettingsService.js.map